import React, { useState } from 'react';
import BrochureModal from './BrochureModal';
import './BrochureSection.css';

const BrochureSection = ({ config }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="brochure-section mobile-only">
      <div className="brochure-content">
        <button 
          className="brochure-btn"
          onClick={() => {
            // Google Analytics event tracking
            if (typeof gtag !== 'undefined') {
              gtag('event', 'brochure_modal_open', {
                event_category: 'engagement',
                event_label: 'Get the Brochure button clicked'
              });
            }
            setIsModalOpen(true);
          }}
        >
          <span>{config.text}</span>
        </button>
      </div>
      
      <BrochureModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default BrochureSection;
